module.exports = __webpack_public_path__ + "static/media/hero_video_desktop.fd0c2df6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/hero_video_desktop.mp4
// module id = 58
// module chunks = 0